import axios from "axios";
import { Payout_Service } from "../Url";
import { RegenData } from "../../components/PayoutManagement/helper/payoutdatasample";

export const payoutMissingMonthforGenReportAction ={
    PAYOUT_MISSING_MONTH_FOR_GEN_REPORT_SUCCESS: "PAYOUT_MISSING_MONTH_FOR_GEN_REPORT_SUCCESS",
    PAYOUT_MISSING_MONTH_FOR_GEN_REPORT_ERROR: "PAYOUT_MISSING_MONTH_FOR_GEN_REPORT_ERROR",
}


export function payoutMissingMonthforGenReportSuccess(props) {
   const { accessToken, financialYear } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "Post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/get/missingMonths?year=${financialYear}`,
        // url: `http://localhost:8301/partner-payout-service/reports/get/missingMonths?year=${financialYear}`,
      });
      const data = response.data;
      dispatch({
        type: payoutMissingMonthforGenReportAction.PAYOUT_MISSING_MONTH_FOR_GEN_REPORT_SUCCESS,
        payload: data.data,
      });
      console.log("Payout Missing Month for Gen Report2:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: payoutMissingMonthforGenReportAction.PAYOUT_MISSING_MONTH_FOR_GEN_REPORT_ERROR,
        payload: error.message || "Failed to fetch missing months for generation report",
      });
      return error;
    }
  };
}